import type { JSX } from "react";
import { cn } from "./cn";
import { CalendarEvent } from "./CalendarEvent";

export interface DayScheduleEvent {
  readonly title: string;
  readonly time?: string;
  readonly color: string;
}

export interface DayScheduleProps {
  /** List of events for the day */
  readonly events: readonly DayScheduleEvent[];
  /** Extra className */
  readonly className?: string;
}

/**
 * A vertical list of calendar events for a single day.
 */
export function DaySchedule({ events, className }: DayScheduleProps): JSX.Element {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {events.map((event) => (
        <CalendarEvent
          key={event.title}
          title={event.title}
          time={event.time}
          color={event.color}
        />
      ))}
    </div>
  );
}
